import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import '../../context/global';
import ChatContext from '../../context/index';

import './chattranslate.scss';

const ChatTranslate = ({ ...props }) => {
  const { closeTranslatePopup, doTranslate, showTranslatePopup, excerptMessage } = props;

  const handleClose = () => {
    closeTranslatePopup();
  };

  const handleTranslate = e => {
    doTranslate(e.target.dataset.language);
  };

  const { trans, availableLang } = useContext(ChatContext);
  const arrayAvailableLang = availableLang.split(',');
  const LanguageSelections = Object.keys(arrayAvailableLang).map(key => {
    return (
      <button
        key={key}
        type="button"
        className="chat-translate-item"
        onClick={handleTranslate}
        data-language={global.langCode[arrayAvailableLang[key]]}
      >
        <div
          className="chat-translate-item-wrapper"
          data-language={global.langCode[arrayAvailableLang[key]]}
        >
          <div
            className="chat-translate-flag"
            style={{
              backgroundImage: `url(${process.env.REACT_APP_PORTAL_URL}/static/img/flags/${arrayAvailableLang[key]}.svg)`,
              backgroundSize: 'cover',
            }}
            data-language={global.langCode[arrayAvailableLang[key]]}
          />
          {global.langText[arrayAvailableLang[key]]}
        </div>
      </button>
    );
  });
  if (showTranslatePopup) {
    return (
      <div className="chat-translate">
        <div className="chat-translate-box">
          <button type="button" className="chat-translate-close-box" onClick={handleClose}>
            <i className="material-icons">close</i>
          </button>
          <span className="excerpt-message">
            &quot;
            {excerptMessage}
            &quot;
          </span>
          <span>{trans['Translate to:']}</span>
          {LanguageSelections}
        </div>
      </div>
    );
  }
  return null;
};

ChatTranslate.propTypes = {
  closeTranslatePopup: PropTypes.func.isRequired,
  doTranslate: PropTypes.func.isRequired,
  showTranslatePopup: PropTypes.bool.isRequired,
  excerptMessage: PropTypes.string.isRequired,
};

export default ChatTranslate;
